import { render, staticRenderFns } from "./ViewVerification.vue?vue&type=template&id=536e7f3c&"
import script from "./ViewVerification.vue?vue&type=script&lang=js&"
export * from "./ViewVerification.vue?vue&type=script&lang=js&"
import style0 from "./ViewVerification.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports